/* jshint esversion: 6 */
import React from 'react';
import Modal from 'app/components/common/Modal.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConnectMixin from 'app/mixins/ConnectMixin.js';
import SocialButton from 'app/components/common/SocialButton.jsx';
import SubscriptionModule from 'app/mixins/SubscriptionModule.js';
import SearchControl from 'app/components/common/SearchControl.jsx';
import SocialAvatar from 'app/components/common/SocialAvatar.jsx';

class ReuseSocialInputModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            availableCreds: [],
            filteredCreds: [],
            searchActive: false
        };

        this.searchChangeHandler = this.searchChangeHandler.bind(this);

    }

    componentDidMount() {
        if (this.props.credList !== undefined) {
            this.setState({
                availableCreds: this.props.credList
            });
        }
    }

    searchChangeHandler(e, search) {
        let nextFilteredCreds = [],
            nextSearchActive = true,
            searchRegex = new RegExp(search, "i");

        if (search === '') {
            nextSearchActive = false;
        }

        this.state.availableCreds.map((cred) => {
            if (cred.scName.match(searchRegex)) {
                nextFilteredCreds.push(cred);
            };
        });

        this.setState({
            filteredCreds: nextFilteredCreds,
            searchActive: nextSearchActive
        });

    }

    resetSearch() {

        this.setState({
            filteredCreds: [],
            searchActive: false
        });

    }

    render() {
        let modalTitle = "Reuse Social Input",
            modalContainer = null,
            closeAction = this.props.closeAllModals,
            Icon = null,
            iconElement = null,
            buttonClass = 'btn-primary',
            placeholder = "Search connected inputs",
            connectButton = null,
            inputsToShow = this.state.availableCreds;

        if (this.props.service !== undefined) {
            modalTitle = `Reuse ${ConstantMixin.getInputServiceByCode(this.props.service)} Input`;
            Icon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.service)];
            iconElement = <Icon small={true} bare={true} white={true}/>;
            buttonClass += " " + ConstantMixin.getIconIndexByCode(this.props.service);
            placeholder = 'Search connected ' + ConstantMixin.getInputServiceByCode(this.props.service) + ' social inputs';
        }

        connectButton = (
            <button className={buttonClass} onClick={(e) => {
                e.preventDefault();
                this.props.newConnection(this.props.service);
            }}>
                {iconElement} <span>Connect New</span>
            </button>
        );

        if (this.state.searchActive) {
            inputsToShow = this.state.filteredCreds;
        }


        modalContainer = (
            <div>
                <div className="dlvr-modal-controls social-modal">
                    <div className="modal-controls-wrapper">
                        <div className="service-connector">
                            {connectButton}
                        </div>
                        <div className="search-control">
                            <SearchControl
                                {...this.props}
                                changeHandler={this.searchChangeHandler}
                                placeholder={placeholder}
                                extraClasses="social-modal-search"
                                wrapperClass="social-modal"
                                defaultFocus={false}/>
                        </div>
                    </div>
                </div>
                <ul className="reuse-inputs">
                    {inputsToShow.map((cred) => {
                        return (
                            <li key={cred.scID} onClick={(e) => {
                                let input = {
                                    type: this.props.service,
                                    scID: cred.scID
                                };

                                // cred needs to be reauthed
                                if (cred.sysActionFlag === 1) {
                                    this.props.newConnection(this.props.service, cred);
                                    return;
                                }

                                this.props.reuseInput(input);
                                this.props.closeAllModals();

                            }}>
                                <SocialButton
                                    {...this.props}
                                    social={{
                                        psID: this.props.service,
                                        icon: cred.icon,
                                        inactive: cred.sysActionFlag,
                                        name: cred.scName
                                    }}
                                    context={"reuse-input"}/>
                            </li>
                        )
                    })}
                    <SocialButton
                        {...this.props}
                        connect={true}
                        connectAction={() => {
                            this.props.newConnection(this.props.service);
                        }}/>
                </ul>
            </div>
        );

        return (
            <Modal
                headerContent={modalTitle}
                menuContent={null}
                content={modalContainer}
                showClose={true}
                close={closeAction} />
        )
    }
}

ReuseSocialInputModal.displayName = ReuseSocialInputModal;

export default ReuseSocialInputModal;
